exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Button__button--c8151d {\n  background-color: #ff5c39;\n  color: white;\n\n  display: inline-block;\n  box-sizing: border-box;\n\n  border: none;\n  border-radius: 4px;\n\n  padding: 12px;\n  padding-left: 18px;\n  padding-right: 18px;\n\n  text-align: center;\n  text-decoration: none;\n}\n", ""]);

// exports
exports.locals = {
	"button": "Button__button--c8151d"
};


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:6]"}!/tw-build/dev/global-site/~/postcss-loader!./component/Button/Button.css
// module id = 101
// module chunks = 0